import styled from 'styled-components';
import colors from '../../../../../../../../styles/themes/TCP/colors';

export const SideNavContainer = styled.div(
  ({ theme }) => `
    .category-item--subcatgroup {
      padding-left: 20px;
      padding-top: 4px;
      & ~ .cat-group--moretoggle {
        padding-left: 20px;
      }
      li{
        margin-bottom: 4px;
      }
      .category-item--active{
        font-weight: ${theme.typography.fontWeights.extrabold};
      }
    }
`
);

export const ListBox = styled.div(
  () => `
    margin-bottom: 6px;
    & > .category-item--subcatgroup {
      padding-top: 16px;
    }

    .sideNav-listBox-category-group {
      font-size: 16px;
      font-family: Nunito;
      font-weight: bold;
      letter-spacing: 0.45px;
    }
  `
);
export const ArrowSpan = styled.span(
  () =>
    `
    color: ${colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
    .show-more-less {
      margin-left : 4px;
      top: 1px;
      position: relative;
    }
  `
);
